import { QUEUE_SHELL, QUEUE_SCROLL, QUEUE_TABLE, QUEUE_THEAD, QUEUE_TH, QUEUE_TD, QUEUE_EMPTY } from './queueTableStyles';
import React from 'react';
import { fmtDate } from '../../lib/dates';

// The "Feedback due" queue (brief-briefs-tab-row §5). One row per awarded brief
// whose event has passed and feedback isn't recorded. Sorted oldest-event-first
// upstream (deriveFeedbackDue) because feedback decays. Lapsed requests still
// appear, marked, until recorded or dismissed. The row is a finder — "Give
// feedback" opens the brief, where the banner with the award + value + supplier
// is the right place to actually record it (§6).

const FONT = "font-['Metropolis']";

function daysAgoLabel(n) {
  if (n == null) return '—';
  if (n === 0) return 'today';
  if (n === 1) return 'yesterday';
  return `${n} days ago`;
}

const money = (v) => (v == null ? '—' : `£${Number(v).toLocaleString('en-GB')}`);

export default function FeedbackDueList({ items, onOpen }) {
  if (!items || items.length === 0) {
    return (
      <div className="mx-8 mt-8">
        <div className={`${FONT} ${QUEUE_EMPTY}`}>
          <div className="text-[14px] font-bold text-ink mb-1">Nothing waiting on feedback</div>
          <p className="text-[12px] text-[#51534A]">When an awarded event finishes and its feedback hasn't been recorded, it appears here — oldest first.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-8 mt-6">
      <p className={`${FONT} text-[12px] text-[#51534A] mb-3`}>
        {items.length} awarded event{items.length === 1 ? '' : 's'} still need{items.length === 1 ? 's' : ''} feedback — oldest first, because feedback decays.
      </p>
      <div className={`${QUEUE_SHELL} ${QUEUE_SCROLL}`}>
        <table className={`${QUEUE_TABLE} min-w-[720px]`}>
          <thead className={QUEUE_THEAD}>
            <tr>
              <th scope="col" className={QUEUE_TH}>Brief</th>
              <th scope="col" className={QUEUE_TH}>Supplier</th>
              <th scope="col" className={QUEUE_TH}>Event finished</th>
              <th scope="col" className={`${QUEUE_TH} text-right`}>Award value</th>
              <th scope="col" className={`${QUEUE_TH} text-right`} aria-label="Action" />
            </tr>
          </thead>
          <tbody>
            {items.map(({ brief, state, daysSinceEvent, eventDate, awardValue }) => {
              const lapsed = state === 'lapsed';
              const supplierName = brief.awarded_supplier?.supplier_name || 'the supplier';
              return (
                <tr key={brief.id} className={`${FONT} border-b border-line last:border-0 hover:bg-[#F7F9F0] ${lapsed ? 'opacity-80' : ''}`}>
                  <td className={QUEUE_TD}>
                    <button type="button" onClick={() => onOpen?.(brief.id)}
                      className="text-[13px] font-semibold text-ink hover:text-fusion-forest text-left leading-snug">
                      {brief.brief_name || 'Untitled brief'}
                    </button>
                    {(brief.fusion_project_name || brief.fusion_project_number) && (
                      <div className="text-[11px] text-[#9BA08C] mt-0.5">
                        {brief.fusion_project_number ? `${brief.fusion_project_number} · ` : ''}{brief.fusion_project_name || ''}
                      </div>
                    )}
                  </td>
                  <td className="px-4 py-3 align-top text-[12.5px] text-fusion-mid-grey">{supplierName}</td>
                  <td className={QUEUE_TD}>
                    <div className="text-[12.5px] text-ink">{daysAgoLabel(daysSinceEvent)}</div>
                    {eventDate && <div className="text-[11px] text-[#9BA08C]">{fmtDate(eventDate, '')}</div>}
                    {lapsed && (
                      <span className="inline-block mt-1 text-[9px] font-bold uppercase tracking-[0.1em] rounded px-1.5 py-0.5 bg-[#EEF1E6] text-[#7A7D6F]">Lapsed</span>
                    )}
                  </td>
                  <td className="px-4 py-3 align-top text-right text-[12.5px] tabular-nums text-ink">{money(awardValue)}</td>
                  <td className="px-4 py-3 align-top text-right">
                    <button type="button" onClick={() => onOpen?.(brief.id)}
                      className="text-[11px] font-bold rounded-full px-3.5 py-1.5 text-white bg-[#B47509] hover:brightness-110 transition-[filter] whitespace-nowrap">
                      Give feedback
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
